import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=abea700c"
import script from "./Exhibition.vue?vue&type=script&lang=js"
export * from "./Exhibition.vue?vue&type=script&lang=js"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=abea700c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports